import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import NavigationBar from '../common/navigationBar';
import patientPortalSignup from './images/QRCode_PatientPortal_large_cropped.png';
import './styles.css';

class PatientPortalSignup extends Component {
  /**************
   * Properties *
   **************/
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu',
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="patient-portal-signup">
        <ImageBackground id="background" />
        <img className="portal-signup" src={patientPortalSignup} alt="" />
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}

export default withRouter(PatientPortalSignup);
